// extracted by mini-css-extract-plugin
export default {"root":"AbXhA4RE4VFTS5CZf9kL","item":"xzqigQcegGZtASNfuJ2e"};